import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useExpressCheckoutButtonsData } from '../provider/useExpressCheckoutButtonsData';
import { getPaymentBreakdown } from '../utils/getPaymentBreakdown';
import { getPaymentAmount } from '../utils/getPaymentAmount';
import loadable from '@loadable/component';
import { useFunctionResultObservation } from '@wix/function-result-observation';
import { RESULT_PROP_NAME } from '../utils/consts';
import { getOrderItemsFromCheckout } from '../utils/getOrderItemsFromCheckout';
import { getEstimatedPaymentData } from '../utils/getEstimatedPaymentData';
const CashierExpressCheckoutWidgetLazy = loadable(() => import( /* webpackChunkName: "CashierExpressCheckoutWidget" */'@wix/cashier-express-checkout-widget').then(module => module.CashierExpressCheckoutWidget));
export let ExpressCheckoutButtonsDataHooks = /*#__PURE__*/function (ExpressCheckoutButtonsDataHooks) {
  ExpressCheckoutButtonsDataHooks["root"] = "ExpressCheckoutButtonsDataHooks.root";
  return ExpressCheckoutButtonsDataHooks;
}({});
export const ExpressCheckoutButtons = _ref => {
  let {
    checkout,
    layout,
    theme,
    buttonStyle,
    isShippable,
    estimatedTotal,
    canStartPayment = true,
    useEstimationFlow = true
  } = _ref;
  const data = useExpressCheckoutButtonsData();
  const {
    withObservation
  } = useFunctionResultObservation({
    resultPropName: RESULT_PROP_NAME
  });
  const {
    currency,
    locale,
    domain,
    meta,
    demoMode,
    taxOnProduct,
    onCancel,
    onClick
  } = data != null ? data : {};
  const onShippingContactSelected = withObservation(data, 'onShippingContactSelected');
  const onPaymentAuthorized = withObservation(data, 'onPaymentAuthorized');
  const onShippingMethodSelected = withObservation(data, 'onShippingMethodSelected');
  const getInitialPaymentData = withObservation(data, 'getInitialPaymentData');
  const onPaymentMethodsInit = withObservation(data, 'onPaymentMethodsInit');
  if (!data) {
    return null;
  }
  const {
    orderItems,
    paymentBreakdown,
    paymentAmount
  } = getPaymentData({
    estimatedTotal,
    checkout,
    useEstimationFlow,
    taxOnProduct
  });
  if (Number(paymentAmount) === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": ExpressCheckoutButtonsDataHooks.root
  }, /*#__PURE__*/React.createElement(CashierExpressCheckoutWidgetLazy, _extends({
    currency: currency,
    demoMode: demoMode,
    theme: theme,
    buttonStyle: buttonStyle,
    layout: layout,
    locale: locale,
    domain: domain,
    meta: meta,
    paymentLabel: "forApplePay",
    orderItems: orderItems,
    requestShipping: isShippable,
    paymentBreakdown: paymentBreakdown,
    paymentAmount: paymentAmount,
    onPaymentMethodsAmountInit: onPaymentMethodsInit,
    onPaymentAuthorized: paymentInfo => onPaymentAuthorized(paymentInfo, checkout == null ? void 0 : checkout.id, isShippable, checkout == null ? void 0 : checkout.cartId, useEstimationFlow),
    onCancel: () => onCancel(),
    onClick: () => {
      onClick();
      return {
        canceled: !canStartPayment
      };
    },
    onShippingMethodSelected: shippingMethod => onShippingMethodSelected(shippingMethod, checkout == null ? void 0 : checkout.id),
    onShippingContactSelected: shippingContact => onShippingContactSelected(shippingContact, checkout == null ? void 0 : checkout.id)
  }, useEstimationFlow ? {
    getInitialPaymentData: () => getInitialPaymentData()
  } : {})));
};
const getPaymentData = _ref2 => {
  let {
    estimatedTotal = '0',
    checkout,
    useEstimationFlow = true,
    taxOnProduct = true
  } = _ref2;
  if (useEstimationFlow) {
    return getEstimatedPaymentData(estimatedTotal);
  }
  return {
    orderItems: getOrderItemsFromCheckout(checkout),
    paymentBreakdown: getPaymentBreakdown(checkout, taxOnProduct),
    paymentAmount: getPaymentAmount(checkout)
  };
};
//# sourceMappingURL=ExpressCheckoutButtons.js.map